var React = require('react');

function ItemSelected (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#418BCA","cx":"7.5","cy":"7.75","r":"6.99","key":0}),React.createElement("path",{"fill":"#2F6FA3","d":"M7.5 15.25c-4.136 0-7.5-3.364-7.5-7.5S3.364.25 7.5.25 15 3.614 15 7.75s-3.365 7.5-7.5 7.5zm0-13.98c-3.573 0-6.48 2.907-6.48 6.48s2.907 6.48 6.48 6.48 6.48-2.907 6.48-6.48-2.907-6.48-6.48-6.48z","key":1}),React.createElement("path",{"fill":"#FFF","d":"M6.772 11.318L3.238 7.554l.744-.699L6.737 9.79l4.391-5.128.775.664z","key":2})]);
}

ItemSelected.defaultProps = {"width":"15","height":"15.5","viewBox":"0 0 15 15.5"};

module.exports = ItemSelected;

ItemSelected.default = ItemSelected;
